import { render, staticRenderFns } from "./ProcurementTaskPanel.vue?vue&type=template&id=711aaed4&scoped=true"
import script from "./ProcurementTaskPanel.vue?vue&type=script&lang=js"
export * from "./ProcurementTaskPanel.vue?vue&type=script&lang=js"
import style0 from "./ProcurementTaskPanel.vue?vue&type=style&index=0&id=711aaed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711aaed4",
  null
  
)

export default component.exports